<template>
  <svg class="edu-school-svg" width="90" height="90" viewBox="0 0 90 90">
    <g id="Group_1120" data-name="Group 1120" transform="translate(-1360 -719)">
      <path
        id="Path_1635"
        data-name="Path 1635"
        d="M77.154,12a1.154,1.154,0,1,0,1.154,1.154A1.154,1.154,0,0,0,77.154,12Z"
        transform="translate(1359 708.154)"
        fill="#6c63ff"
      />
      <path
        id="Path_1636"
        data-name="Path 1636"
        d="M55.692,13A42.692,42.692,0,1,0,98.385,55.692,42.692,42.692,0,0,0,55.692,13Z"
        transform="translate(1349 708)"
      />
      <path
        id="Path_1637"
        data-name="Path 1637"
        d="M83.615,11a4.615,4.615,0,1,0,4.615,4.615A4.615,4.615,0,0,0,83.615,11Z"
        transform="translate(1359.462 708)"
        fill="#6c63ff"
      />
      <path
        id="Path_1638"
        data-name="Path 1638"
        d="M87.308,22a2.308,2.308,0,1,0,2.308,2.308A2.308,2.308,0,0,0,87.308,22Z"
        transform="translate(1360.385 709.692)"
        fill="#ec615b"
      />
      <path
        id="Path_1639"
        data-name="Path 1639"
        d="M91.769,76.308a2.308,2.308,0,1,0,2.308,2.308A2.308,2.308,0,0,0,91.769,76.308ZM15.615,59a4.615,4.615,0,1,0,4.615,4.615A4.615,4.615,0,0,0,15.615,59Z"
        transform="translate(1349 715.385)"
        fill="#6c63ff"
      />
      <path
        id="Path_1640"
        data-name="Path 1640"
        d="M25.308,85a2.308,2.308,0,1,0,2.308,2.308A2.308,2.308,0,0,0,25.308,85Z"
        transform="translate(1350.846 719.385)"
        fill="#ec615b"
      />
      <path
        id="Path_1641"
        data-name="Path 1641"
        d="M18.885,51.615A2.885,2.885,0,1,0,21.769,54.5,2.885,2.885,0,0,0,18.885,51.615ZM89.269,32A1.731,1.731,0,1,0,91,33.731,1.731,1.731,0,0,0,89.269,32Z"
        transform="translate(1349.77 711.231)"
        fill="#fff"
      />
      <g id="Group_1119" data-name="Group 1119" transform="translate(3.691 2)">
        <path
          id="Path_1642"
          data-name="Path 1642"
          d="M49.292,73.823a4.244,4.244,0,0,1-2.967-1.217,3.849,3.849,0,0,0-2.682-1.14H27.8a1.115,1.115,0,0,1-1.1-1.128V41.243a1.116,1.116,0,0,1,1.1-1.13h42.99a1.116,1.116,0,0,1,1.1,1.13V70.336a1.115,1.115,0,0,1-1.1,1.129H54.942a3.863,3.863,0,0,0-2.684,1.14A4.229,4.229,0,0,1,49.292,73.823Z"
          transform="translate(1351.287 706.158)"
          fill="#84a7d7"
        />
        <path
          id="Path_1643"
          data-name="Path 1643"
          d="M70.767,40.827a.422.422,0,0,1,.419.422V70.343a.422.422,0,0,1-.419.422H54.921A4.525,4.525,0,0,0,51.774,72.1a3.559,3.559,0,0,1-5,0,4.522,4.522,0,0,0-3.146-1.329H27.778a.422.422,0,0,1-.419-.422V41.25a.422.422,0,0,1,.419-.422h42.99m0-1.414H27.778A1.809,1.809,0,0,0,26,41.25V70.344a1.809,1.809,0,0,0,1.778,1.837H43.623a3.2,3.2,0,0,1,2.219.949,4.879,4.879,0,0,0,6.859,0,3.2,3.2,0,0,1,2.22-.949H70.767a1.809,1.809,0,0,0,1.778-1.837V41.25a1.81,1.81,0,0,0-1.778-1.837Z"
          transform="translate(1351.308 706.15)"
          fill="#6d5856"
        />
        <path
          id="Path_1644"
          data-name="Path 1644"
          d="M50.063,65.547a3.539,3.539,0,1,0,3.4,3.536A3.468,3.468,0,0,0,50.063,65.547Z"
          transform="translate(1350.695 706.419)"
          fill="#606060"
        />
        <path
          id="Path_1645"
          data-name="Path 1645"
          d="M29.841,68.627V41.468l1.51-4.044a1.256,1.256,0,0,1,1.179-.838c6.681.015,12.557,1.269,16.121,3.443l.312.193h1.167l.294-.163c3.834-2.082,9.848-3.376,16.087-3.459a1.378,1.378,0,0,1,1.306.921l1.471,3.945v27.16Z"
          transform="translate(1351.194 706.121)"
          fill="#fffef4"
        />
        <path
          id="Path_1646"
          data-name="Path 1646"
          d="M32.507,37.3c6.565.014,12.317,1.234,15.78,3.347l.157.1.317.193h1.514l.3-.162.144-.079c3.748-2.036,9.648-3.3,15.766-3.381a.7.7,0,0,1,.681.471l1.425,3.823V67.927H30.5V41.608l1.463-3.922a.574.574,0,0,1,.544-.386m0-1.414A1.933,1.933,0,0,0,30.7,37.174l-1.555,4.168v28H69.947v-28L68.43,37.274A2.061,2.061,0,0,0,66.482,35.9c-6.34.084-12.468,1.409-16.4,3.542l-.146.08H49.13l-.157-.1c-3.664-2.237-9.664-3.527-16.464-3.541Z"
          transform="translate(1351.215 706.114)"
          fill="#6d5856"
        />
        <path
          id="Path_1647"
          data-name="Path 1647"
          d="M66.709,63.358,49.444,64.51,32.124,63.358l-1.812,4.248H68.52Z"
          transform="translate(1351.18 706.397)"
          fill="#bebacb"
        />
        <path
          id="Path_1648"
          data-name="Path 1648"
          d="M52.417,42.8a.241.241,0,0,1-.223-.156.254.254,0,0,1,.131-.329,25.9,25.9,0,0,1,11.768-2.122.25.25,0,0,1,.229.267.229.229,0,0,1-.256.238A25.383,25.383,0,0,0,52.51,42.779.214.214,0,0,1,52.417,42.8ZM64.08,44.434h-.014a24.86,24.86,0,0,0-2.559-.017H61.5a.247.247,0,0,1-.243-.241.25.25,0,0,1,.232-.264c.865-.037,1.74-.031,2.606.017a.25.25,0,0,1,.229.267A.247.247,0,0,1,64.08,44.434Zm-6.859.544a.244.244,0,0,1-.237-.2.252.252,0,0,1,.186-.3c.635-.14,1.288-.258,1.94-.349a.246.246,0,0,1,.273.217.252.252,0,0,1-.209.284c-.64.089-1.281.2-1.9.34A.213.213,0,0,1,57.22,44.977Zm-4.8,1.558a.241.241,0,0,1-.223-.156.254.254,0,0,1,.131-.329,26.992,26.992,0,0,1,3.373-1.2.242.242,0,0,1,.3.178.255.255,0,0,1-.171.31,26.694,26.694,0,0,0-3.314,1.181A.256.256,0,0,1,52.417,46.535Zm0,3.736a.241.241,0,0,1-.223-.156.254.254,0,0,1,.131-.329,25.86,25.86,0,0,1,11.768-2.123.25.25,0,0,1,.229.267.228.228,0,0,1-.256.238A25.282,25.282,0,0,0,52.51,50.252.23.23,0,0,1,52.417,50.271ZM56.579,52.6a.244.244,0,0,1-.236-.194.253.253,0,0,1,.18-.3,25.733,25.733,0,0,1,7.571-.7.25.25,0,0,1,.229.267.227.227,0,0,1-.256.238,24.99,24.99,0,0,0-7.432.687A.281.281,0,0,1,56.579,52.6Zm-4.162,1.407a.243.243,0,0,1-.224-.156.257.257,0,0,1,.132-.33c.709-.306,1.433-.583,2.149-.823a.242.242,0,0,1,.306.163.256.256,0,0,1-.156.318c-.7.235-1.416.509-2.113.81A.247.247,0,0,1,52.417,54.006Zm0,3.736a.241.241,0,0,1-.223-.156.254.254,0,0,1,.131-.329,25.619,25.619,0,0,1,11.826-1.83.253.253,0,0,1-.014.505h-.014A25.169,25.169,0,0,0,52.51,57.722.2.2,0,0,1,52.417,57.742Zm0,3.737a.243.243,0,0,1-.233-.184.254.254,0,0,1,.167-.312A35.032,35.032,0,0,1,64.03,59.631a.253.253,0,0,1-.007.505h-.007a34.612,34.612,0,0,0-11.534,1.333A.185.185,0,0,1,52.417,61.479ZM40.2,40.86l-.03,0a24.947,24.947,0,0,0-4.619-.161.237.237,0,0,1-.255-.238.251.251,0,0,1,.229-.267,25.787,25.787,0,0,1,4.705.165.25.25,0,0,1,.211.281A.247.247,0,0,1,40.2,40.86Zm3.406.677a.254.254,0,0,1-.061-.008c-.561-.152-1.132-.286-1.7-.4a.251.251,0,0,1-.193-.3.237.237,0,0,1,.283-.2c.576.114,1.159.251,1.729.405a.254.254,0,0,1,.174.309A.241.241,0,0,1,43.609,41.537ZM47.2,42.8a.222.222,0,0,1-.093-.02c-.7-.3-1.414-.575-2.118-.811a.255.255,0,0,1-.156-.317.244.244,0,0,1,.3-.164c.717.24,1.442.519,2.155.826a.256.256,0,0,1,.131.329A.239.239,0,0,1,47.2,42.8Z"
          transform="translate(1351.032 706.158)"
          fill="#472b29"
        />
        <g id="Group_1109" data-name="Group 1109" transform="translate(1386.33 750.045)">
          <path
            id="Path_1649"
            data-name="Path 1649"
            d="M47.2,46.5a.222.222,0,0,1-.093-.02,25.367,25.367,0,0,0-11.557-2.082.241.241,0,0,1-.255-.238.25.25,0,0,1,.229-.267A25.805,25.805,0,0,1,47.3,46.011a.256.256,0,0,1,.131.329A.24.24,0,0,1,47.2,46.5Z"
            transform="translate(-35.298 -43.849)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1110" data-name="Group 1110" transform="translate(1386.329 753.781)">
          <path
            id="Path_1650"
            data-name="Path 1650"
            d="M38.74,48.112h-.016a25.707,25.707,0,0,0-3.17-.019.255.255,0,0,1-.255-.238.25.25,0,0,1,.229-.267,26.237,26.237,0,0,1,3.227.021.249.249,0,0,1,.226.269A.245.245,0,0,1,38.74,48.112Z"
            transform="translate(-35.298 -47.547)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1111" data-name="Group 1111" transform="translate(1392.062 754.145)">
          <path
            id="Path_1651"
            data-name="Path 1651"
            d="M47.378,50.191a.222.222,0,0,1-.093-.02,25.92,25.92,0,0,0-5.877-1.762.253.253,0,0,1-.2-.291.244.244,0,0,1,.279-.208,26.467,26.467,0,0,1,5.983,1.8.255.255,0,0,1,.131.329A.24.24,0,0,1,47.378,50.191Z"
            transform="translate(-41.205 -47.907)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1112" data-name="Group 1112" transform="translate(1386.329 757.517)">
          <path
            id="Path_1652"
            data-name="Path 1652"
            d="M47.2,53.892a.222.222,0,0,1-.093-.02A25.341,25.341,0,0,0,35.553,51.79a.253.253,0,0,1-.026-.505A25.875,25.875,0,0,1,47.3,53.406a.256.256,0,0,1,.131.329A.239.239,0,0,1,47.2,53.892Z"
            transform="translate(-35.298 -51.245)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1113" data-name="Group 1113" transform="translate(1386.274 761.53)">
          <path
            id="Path_1653"
            data-name="Path 1653"
            d="M43.069,56.279a.255.255,0,0,1-.049-.005,28.285,28.285,0,0,0-7.524-.5.263.263,0,0,1-.255-.238.25.25,0,0,1,.229-.267,28.823,28.823,0,0,1,7.646.505.252.252,0,0,1,.189.3A.245.245,0,0,1,43.069,56.279Z"
            transform="translate(-35.241 -55.217)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1114" data-name="Group 1114" transform="translate(1395.972 762.643)">
          <path
            id="Path_1654"
            data-name="Path 1654"
            d="M47.5,57.576a.222.222,0,0,1-.093-.02,21.081,21.081,0,0,0-2-.744.255.255,0,0,1-.162-.315.245.245,0,0,1,.3-.169,21.476,21.476,0,0,1,2.043.762.256.256,0,0,1,.131.329A.239.239,0,0,1,47.5,57.576Z"
            transform="translate(-45.234 -56.319)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1115" data-name="Group 1115" transform="translate(1386.385 765.766)">
          <path
            id="Path_1655"
            data-name="Path 1655"
            d="M47.2,61.281a.224.224,0,0,1-.067-.01A34.629,34.629,0,0,0,35.6,59.938H35.6a.253.253,0,0,1-.007-.505,35.018,35.018,0,0,1,11.68,1.353.254.254,0,0,1,.167.312A.244.244,0,0,1,47.2,61.281Z"
            transform="translate(-35.355 -59.409)"
            fill="#472b29"
          />
        </g>
        <g id="Group_1117" data-name="Group 1117" transform="translate(1382.645 743.125)">
          <path
            id="Path_1658"
            data-name="Path 1658"
            d="M49.452,65.793a.462.462,0,0,1-.122-.016,65.176,65.176,0,0,0-17.341-2h0a.474.474,0,0,1-.343-.148.514.514,0,0,1-.143-.358V37h.97V62.761h.1a66.282,66.282,0,0,1,16.4,1.878V40.031h.97V65.288a.514.514,0,0,1-.188.4A.475.475,0,0,1,49.452,65.793Z"
            transform="translate(-31.5 -37)"
            fill="#6d5856"
          />
        </g>
        <g id="Group_1118" data-name="Group 1118" transform="translate(1400.111 743.125)">
          <path
            id="Path_1659"
            data-name="Path 1659"
            d="M49.985,65.793a.476.476,0,0,1-.3-.105.514.514,0,0,1-.188-.4V40.031h.97V64.639a65.195,65.195,0,0,1,16.5-1.878V37h.97V63.268a.514.514,0,0,1-.143.358.474.474,0,0,1-.343.148c-.18,0-.388,0-.583,0a64.549,64.549,0,0,0-16.761,2.006A.462.462,0,0,1,49.985,65.793Z"
            transform="translate(-49.5 -37)"
            fill="#6d5856"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
    name: "EduSchool"
}
</script>

<style lang="scss" scoped>
:root {
  .edu-school-svg {
    #Path_1636 {
      fill: #efeeff;
    }
  }
}
:root.dark-theme {
  .edu-school-svg {
    #Path_1636 {
      fill: #40414b;
    }
  }
}
</style>